import { EncryptionSettings } from 'wizards/models/base/base-models/plan-encryption-settings-model';
import { ScheduleSettingsModels } from 'wizards/models/base/schedule-settings-models';
import { EncryptionAlgorithm } from 'wizards/models/compression-encription-models';

export class BaseConsistencyCheckModel implements EncryptionSettings {
  public ConnectionID: string;
  public EncryptionAlgorithm: EncryptionAlgorithm;
  public EncryptionKeySize: number;
  public EncryptionPassword: string;
  public HybridID: string;
  public Schedule: ScheduleSettingsModels;
  public UseEncryption: boolean;
  public UseServerSideEncryption: boolean;

  public ActualRetentionDelay: string;
  public SerializationSupportRetentionTime: string;
  public SerializationSupportRetentionDelay: string;
  public RetentionDelay: string;
  public RetentionDeleteLastVersion: boolean;
  public RetentionNumberOfVersions: number;
  public RetentionUseDefaultSettings: boolean;
  public RetentionTime: any;
  public UseBackupDate: boolean;
}
